import createSlice from "admin/store/create-slice";
import initialState from "admin/store/initial-state-schema";
import { getApiUrl } from 'shared-kernel/helpers';

const name = 'preinvoice';

const slice = createSlice({
    name,
    initialState,
    reducers: {
        requested: state => ({
            ...state,
            isFetching: true
        }),
        failed: state => ({
            ...state,
            isFetching: false,
            isFailed: true
        }),
        itemReceived: (state, payload) => ({
            ...state,
            isFetching: false,
            item: payload.data
        }),
        getProductsReceived: (state, payload) => ({
            ...state,
            isFetching: false,
            products: payload.data
        }),
        submitReceived: state => ({
            ...state,
            isFetching: false
        })
    }
});

const { requested, failed, itemReceived, submitReceived, getProductsReceived } = slice.actions;

export default slice.reducer;

export const get = orderId => ({
    types: [requested.type, itemReceived.type, failed.type],
    url: getApiUrl(name, 'get'),
    payload: { orderId }
});

export const submit = data => ({
    types: [requested.type, submitReceived.type, failed.type],
    method: 'post',
    url: getApiUrl(name, 'submit'),
    payload: data
});

export const getProducts = (categoryId, brandId) => ({
    types: [requested.type, getProductsReceived.type, failed.type],
    url: getApiUrl('product', 'get4PreInvoice'),
    payload: { categoryId, brandId }
});